module.exports = __webpack_public_path__ + "assets/img/29_194_big.cb12bf5f.jpg";